import { FiltersMobileDrawer } from '../mobile/FiltersMobileDrawer';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FiltersSideBarContainer } from './FiltersSideBarContainer';
import { getDealFinderResultsData, getHasAppliedFilters } from '@state/deal-finder-results/dealFinderResultsSelectors';
import { setFilters } from '@state/deal-finder-results/dealFinderResultsOperations';

export interface FiltersMobileDrawerContainerProps {
  onClose: () => void;
  open: boolean;
}

export const FiltersMobileDrawerContainer = (props: FiltersMobileDrawerContainerProps) => {
  const dispatch = useDispatch();
  const handleOnReset = () => dispatch(setFilters({}));
  const hasAppliedFilters: boolean = useSelector(getHasAppliedFilters);
  const {
    facets: {
      counts: { filtered }
    }
  } = useSelector(getDealFinderResultsData);
  return (
    <FiltersMobileDrawer
      {...props}
      hasAppliedFilters={hasAppliedFilters}
      onReset={handleOnReset}
      count={filtered}
      renderFilters={(props: any) => <FiltersSideBarContainer {...props} />}
    />
  );
};
